import React, { Component } from "react";
import ModalVideo from 'react-modal-video'
import downarrowgreen from "../images/down-arrow-green.svg"
import playicon from "../images/play-icon.svg"
import Modal from 'react-awesome-modal';
import ReactPlayer from 'react-player'
import Rodal from 'rodal';
import '../../node_modules/react-modal-video/css/modal-video.min.css';


// include styles
import 'rodal/lib/rodal.css';
class Twinresults extends  Component{

    constructor () {
        super()
        this.state = {
          isOpen: false
        }
        this.openModal = this.openModal.bind(this)
      }
     
      openModal () {
        this.setState({isOpen: true})
      }
     
    render()
    {
        return (
            <section className="twin-companion-sec">
           <a href="#" data-toggle="modal" data-target="#exampleModal" >
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="title wow  fadeInUp" data-wow-duration="1s" data-wow-delay=".1s">
                            <h2>Unbelievable results from Twin</h2>
                            <p>Your twin collects <strong>3000+ data points </strong> daily and gives you <strong>personalised</strong> treatment to reverse diabetes without <strong>medicines</strong>. 100% safe, simple and natural.</p>
                        </div>
                        <div className="twin-companion-inner">
                            <h3>Our 90 days Average  Results*</h3>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="twin-companion-left wow  fadeInLeft" data-wow-duration="1s" data-wow-delay=".1s">
                                        <h3>Our 90 days Average  Results*</h3>
                                        <ul>
                                            <li>
                                                <h4>94%</h4>
                                                <p>People Stopped Insulin</p>
                                            </li>
                                            <li>
                                                <h4>99%</h4>
                                                <p>People Free of Symptoms</p>
                                            </li>
                                            <li>
                                                <h4>90%</h4>
                                                <p>People Stopped Medicines</p>
                                            </li>
                                            <li>
                                                <h4>2.6<img src={downarrowgreen} alt="" /></h4>
                                                <p>HBA1C Reduction*</p>
                                            </li>
                                            {/* <li>
                                                <h4>80<img src={downarrowgreen} alt="" /></h4>
                                                <p>Fasting Sugar Reduction</p>
                                            </li>
                                            <li>
                                                <h4>4.9kg<img src={downarrowgreen} alt="" /></h4>
                                                <p>Weight Reduced</p>
                                            </li> */}
                                        </ul>
                                    </div>
                                </div>
                                <ModalVideo channel='youtube' isOpen={this.state.isOpen} videoId='_723tJYPRBE' allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"  className="twinVideoPopup" onClose={() => this.setState({isOpen: false})} />
                                <div className="col-md-6">
                                    <div className="twin-companion-right wow fadeInRight" data-wow-duration="1s" data-wow-delay=".2s" >
                                        <div className="companion-right-inner">
                                            <div className="image-holder">
                                                <img data-src="https://res.cloudinary.com/image/upload/v1604992008/NewHome/companion-dr-img-min_bendt4.png" alt="" className="img-fluid lazyload" />
                                            </div>
                                           
                                          
                                           
                                                <div class="text-box">
                                                    <h4>What is Twin's Diabetes Reversal Programme?</h4>
                                                    <a className="btnColor" onClick={this.openModal}><img src={playicon} alt=""/> WATCH VIDEO</a>
                                                </div>
                                                {/* <section>
              
                <Modal visible={this.state.visible} width="800" height="500" effect="fadeInUp" onClickAway={() => this.closeModal()}>
                    <div>
                    <iframe src="https://www.youtube.com/embed/_723tJYPRBE" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen className="twinVideoPopup"></iframe>
                        <a href="javascript:void(0);" onClick={() => this.closeModal()} className="twinpopupclose">Close</a>
                    </div>
                </Modal>
            </section> */}
            <div>
        
            
        {/* <button onClick={this.openModal}>Open</button> */}
        {/* <Rodal visible={this.state.visible} onClose={this.hide.bind(this)}>
                   <div>
                    <iframe src="https://www.youtube.com/embed/_723tJYPRBE" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen className="twinVideoPopup"></iframe>
                       
                    </div>
        </Rodal> */}
      </div>
            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </a>
            {/* modal */}
            {/* <div id="open-modal" class="modal-window">
            <div>
                <a href="#" title="Close" class="modal-close"></a>
                <iframe width="560" height="315" src="https://www.youtube.com/embed/_723tJYPRBE" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>    
        </div>  */}
        </section>
        )
    }
}

export default Twinresults